<template>
<div>
  <div class="title-top-alarm">
    <div>
      <span>{{groupMemberObj.openTitle}}</span>
    </div>
    <div class="line-title"></div>
  </div>
  <div v-if="groupMemberObj.isAdd">
    <el-row style="height: 483px">
      <el-col :span="6" style="height: 100%;overflow-y: auto">
        <div style="margin: 0 20px;height: 40px">
          <el-input size="mini" prefix-icon="el-icon-search" placeholder="输入搜索组织" v-model="filterText" clearable></el-input>
        </div>
        <div style="margin: 0 20px;">
          <el-tree class="filter-tree" show-checkbox :data="treeData" :props="defaultProps" node-key="id" :default-expanded-keys="expandedKeys" :default-checked-keys="isFirst"
                   @check-change="handleCheckChange" :filter-node-method="filterNode" ref="treeData">
          </el-tree>
        </div>
      </el-col>
      <el-col :span="18" style="height: 100%;overflow-y: auto">
        <div style="height: 36px">
          <el-input size="mini" prefix-icon="el-icon-search" placeholder="输入设备编号 / 设备号码 / 服务对象名称搜索" v-model="searchKeyword" style="width: 300px" @blur="blurSearch()"></el-input>
          <el-button size="mini" icon="el-icon-search" type="primary" plain @click="searchWord()">搜索</el-button>
        </div>
        <div style="height: calc(100% - 85px);overflow-y: auto;margin-right: 20px">
          <el-table size="mini" v-loading="loading" element-loading-text="加载中，请耐心等待。" :data="showTable" border style="width: 100%" height="100%" highlight-current-row
                    @current-change="updateCurrentGateway">
            <el-table-column label="" width="35" align="center">
              <template slot-scope="scope">
                <el-radio :label="scope.row.id" v-model="radio"
                          @change.native="getCurrentGateway(scope.row)"
                          style="color: #fff;"></el-radio>
              </template>
            </el-table-column>
            <el-table-column prop="deviceid" label="设备编号" min-width="100" align="center"></el-table-column>
            <el-table-column label="设备类型" min-width="80" align="center">
              <template slot-scope="scope">
                <span>{{getDeviceType(scope.row.devicetype)}}</span>
              </template>
            </el-table-column>
            <el-table-column label="设备号码" min-width="90" align="center">
              <template slot-scope="scope">
                <span>{{getDevicePhone(scope.row)}}</span>
              </template>
            </el-table-column>
            <el-table-column label="电量" width="60" align="center">
              <template slot-scope="scope">
                <span>{{scope.row.battery}}%</span>
              </template>
            </el-table-column>
            <el-table-column prop="p_name" label="服务对象" min-width="80" align="center"></el-table-column>
          </el-table>
        </div>
        <div style="margin-top: 10px;height: 36px;text-align: center">
          <el-pagination v-fixZoom @size-change="handleSizeChange" @current-change="handleCurrentChange"
                         :current-page="currentPage" :page-sizes="[10]" :page-size="pageSize"
                         layout="total, prev, pager, next, jumper" :total="totalCells">
          </el-pagination>
        </div>
      </el-col>
    </el-row>
    <div>
      <el-row>
        <el-col :span="6" style="text-align: right;line-height: 36px"><span style="color: red">*</span><span>成员名称&nbsp;&nbsp;</span></el-col>
        <el-col :span="10"><el-input v-model="groupMemberForm.membername" placeholder="请输入成员名称"></el-input></el-col>
      </el-row>
    </div>
    <div style="margin-top: 15px">
      <el-row style="margin: 0 30px">
        <el-col :span="12">
          <div class="cancel-btn" @click="closeAddEdit()">
            <span>取消</span>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="send-btn" @click="submitAdd()">
            <span>确定</span>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
  <div v-else>
    <el-form style="margin: 10px 50px 0" :model="groupMemberForm" :rules="groupMemberRules" ref="groupMemberForm" label-width="80px" class="demo-ruleForm">
      <el-form-item label="成员名称" prop="membername">
        <el-input v-model="groupMemberForm.membername" placeholder="请输入成员名称"></el-input>
      </el-form-item>
    </el-form>
    <div style="margin-top: 15px">
      <el-row style="margin: 0 30px">
        <el-col :span="12">
          <div class="cancel-btn" @click="closeAddEdit()">
            <span>取消</span>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="send-btn" @click="submitAddEdit('groupMemberForm')">
            <span>确定</span>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
  <div style="height: 20px"></div>

</div>
</template>

<script>
import {
  querybinddevice,
  querybinddevicebyoid,
  updatemsggroupmember,
  addmsggroupmember,
  searchdevice
} from '../../../api/device'
import {queryorg} from '../../../api/organizer'

export default {
  name: 'addEditGroupMember',
  model: {
    prop: 'addGroupMsgShow',
    event: 'change'
  },
  props: {
    groupMemberObj: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      // 左边
      filterText: '',
      treeData: [],
      defaultProps: {
        children: 'child',
        label: 'name'
      },
      expandedKeys: [],
      isFirst: [],
      // 表格
      searchKeyword: '',
      pageSize: 10,
      currentPage: 1,
      totalCells: 0,
      loading: false,
      showTable: [],
      radio: '',
      selectRowData: '',
      // 编辑
      groupMemberForm: {
        membername: ''
      },
      groupMemberRules: {
        membername: [
          {required: true, message: '请输入群聊名称', trigger: 'blur'}
        ]
      }
    }
  },
  created () {
    if (!this.groupMemberObj.isAdd) {
      this.groupMemberForm.membername = this.groupMemberObj.groupMemberRow.member_name
    } else {
      this.getOrgData()
    }
  },
  watch: {
    filterText (val) {
      this.$refs.treeData.filter(val)
    }
  },
  methods: {
    filterNode (value, data) {
      if (!value) return true
      return data.name.indexOf(value) !== -1
    },
    // 左边树
    handleCheckChange () {
      this.currentPage = 1
      this.isFirst = this.$refs.treeData.getCheckedKeys()
      if (this.isFirst.length === 0) {
        this.queryBindDevice()
      } else {
        this.queryBindDeviceByOid()
      }
    },
    // 表格
    getOrgData () {
      this.expandedKeys = []
      this.treeData = []
      this.loading = true
      queryorg().then(res => {
        let orgData = res.data.org
        for (let i = 0; i < orgData.length; i++) {
          if (orgData[i].orgpid === -1) {
            this.expandedKeys.push(orgData[i].id)
          }
        }
        // 所属组织
        let lastLevel = 100
        const arr = res.data.org
        for (let i = 0; i < arr.length; i++) {
          if (arr[i].level < lastLevel) {
            lastLevel = arr[i].level
          }
        }
        for (let i = 0; i < arr.length; i++) {
          if (arr[i].level === lastLevel) {
            this.treeData.push(arr[i])
          }
        }
        for (let i = 0; i < this.treeData.length; i++) {
          const child = this.arrayToNode(arr, this.treeData[i].id)
          if (child.length !== 0) {
            this.treeData[i].child = child
          }
        }
        if (this.isFirst.length === 0) {
          this.queryBindDevice()
        } else {
          this.queryBindDeviceByOid()
        }
      }).catch(() => {
        this.loading = false
      })
    },
    // 递归
    arrayToNode (nodesArray, pid) {
      const vm = this
      return nodesArray.filter(value => {
        if (value.orgpid === pid) {
          const arrayToNode = vm.arrayToNode(nodesArray, value.id)
          if (arrayToNode.length > 0) {
            value.child = arrayToNode
          }
          return value
        }
      })
    },
    blurSearch () {
      this.searchKeyword = this.searchKeyword.replace(/\s*/g, '')
      if (this.searchKeyword === '') {
        this.currentPage = 1
        this.loading = true
        if (this.isFirst.length === 0) {
          this.queryBindDevice()
        } else {
          this.queryBindDeviceByOid()
        }
      }
    },
    searchWord () {
      this.loading = true
      this.currentPage = 1
      this.searchWord1()
    },
    searchWord1 () {
      let data = {
        lessdeviceid: this.searchKeyword,
        page: this.currentPage,
        size: this.pageSize,
        dtype: [901]
      }
      searchdevice(data).then(res => {
        this.loading = false
        this.totalCells = res.data.cnt
        this.showTable = res.data.devices
      }).catch(() => {
        this.loading = false
      })
    },
    queryBindDevice () {
      let params = {
        page: this.currentPage,
        size: this.pageSize,
        isonline: 0
      }
      let data = {
        dtype: [901]
      }
      querybinddevice(params, data).then(res => {
        this.loading = false
        this.totalCells = res.data.cnt
        this.showTable = res.data.devices
      }).catch(() => {
        this.loading = false
      })
    },
    queryBindDeviceByOid () {
      let params = {
        page: this.currentPage,
        size: this.pageSize,
        isonline: 0
      }
      let data = {
        oids: this.isFirst,
        dtype: [901]
      }
      this.loading = true
      querybinddevicebyoid(params, data).then(res => {
        this.totalCells = res.data.cnt
        this.showTable = res.data.devices
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    // 单选选中
    getCurrentGateway (row) {
      this.selectRowData = row
      console.log(1111, this.selectRowData)
      this.groupMemberForm.membername = this.selectRowData.p_name
    },
    // 点击选中的行也可以选中单选按钮
    updateCurrentGateway (row) {
      // 如果没有row,终止
      if (!row) return
      // 把当前行label绑定的值和v-model绑定的值相同时,单选按钮就可以选中
      this.radio = row.id
      this.selectRowData = row
      this.groupMemberForm.membername = this.selectRowData.p_name
      console.log(2222, this.selectRowData)
    },
    getDeviceType (type) {
      return this.commonType.getDeviceType(type)
    },
    getDevicePhone (row) {
      if (row.simcardno !== '' && row.simcardno !== '<nil>') {
        return row.simcardno
      } else {
        if (row.pid > 0) {
          return row.p_phone
        } else {
          return row.h_phone
        }
      }
    },
    handleSizeChange (val) {
      this.pageSize = val
      if (this.searchKeyword === '') {
        if (this.isFirst.length === 0) {
          this.queryBindDevice()
        } else {
          this.queryBindDeviceByOid()
        }
      } else {
        this.searchWord1()
      }
    },
    handleCurrentChange (val) {
      this.currentPage = val
      if (this.searchKeyword === '') {
        if (this.isFirst.length === 0) {
          this.queryBindDevice()
        } else {
          this.queryBindDeviceByOid()
        }
      } else {
        this.searchWord1()
      }
    },
    closeAddEdit () {
      this.$emit('change', false)
    },
    submitAddEdit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.groupMemberObj.isAdd) {} else {
            let data = {
              msgmemberid: this.groupMemberObj.groupMemberRow.id,
              membername: this.groupMemberForm.membername
            }
            updatemsggroupmember(data).then(res => {
              this.$notify({
                title: '成功',
                message: '成功修改成员',
                type: 'success',
                duration: 2000
              })
              this.$emit('change', false)
              this.$emit('getFamilyMember')
            }).catch(() => {
              this.$notify.error({
                title: '失败',
                message: '修改成员失败'
              })
            })
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    submitAdd () {
      if (this.selectRowData === '') {
        this.$message.error('请选择设备。')
        return
      }
      if (this.groupMemberForm.membername === '') {
        this.$message.error('请输入成员名称。')
        return
      }
      let data = {
        msggroupid: this.groupMemberObj.selectGroupMsg.id,
        orgid: this.$store.state.user.orgid,
        did: this.selectRowData.id,
        membertype: 0, // 0 设备 1平台
        membername: this.groupMemberForm.membername
      }
      addmsggroupmember(data).then(res => {
        this.$notify({
          title: '成功',
          message: '成功添加成员',
          type: 'success',
          duration: 2000
        })
        this.$emit('change', false)
        this.$emit('getFamilyMember')
      }).catch(() => {
        this.$notify.error({
          title: '失败',
          message: '添加成员失败'
        })
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/datamanagement/deviceComponents/addEditGroupMember.vue